// promise to support IE browser
import 'promise-polyfill/src/polyfill';

// import '@babel/polyfill';

/*
 * libraries and patching
 * put there only libraries, that doesn't imported or required explicitly and which patch other libraries
 */
import 'jquery';
import 'jquery.cookie';
import 'jquery.quicksearch';
import 'jquery.jstree';
import 'jquery.typewatch';
import 'jquery.orderby';
import 'jquery.checkboxgroup';
import 'jquery.inputcounter';
import 'jquery.select2';
import 'jquery.autonumeric';
import 'jquery.fileupload';
import 'jquery.easing';
import 'jquery.metadata';
import 'jquery.ibutton';
import 'jquery.ui.widget';
import 'jquery-ui';
import 'jquery-ui-timepicker-addon';

import 'underscore.mixins';

import 'backbone.paginator';
import 'backbone.queryparams';
import 'backbone.mixin';

import 'bootstrap';
import 'bootstrap.dropdown-checkbox';

import 'format';

import 'handlebars.helpers';
import 'handlebars.danharper-helpers';
import 'lib/tentacle/filters';
import 'modules/common/controls/register';
import 'modules/rore/controls/register';
import 'controls';

import 'spectrum'; // this is colorpicker
import 'MonthPicker';
import appContext from 'legacy/appcontext';
import store from 'store';
import BigNumber from 'bignumber.js';
import getRouteHref from 'router/utils/getRouteHref';
import vueRouterProxy from 'router/utils/vueRouterProxy';
import _ from 'underscore';
import 'legacy/_patch/patchAppContext';
import Backbone from 'backbone';
import * as Errors from 'legacy/errors';
import Alert from 'legacy/alert';
import translation from 'translation';

appContext.store = store;
appContext.url = getRouteHref;
appContext.router = vueRouterProxy;

// Configure BigNumber
BigNumber.config({
  DECIMAL_PLACES: 8,
  ROUNDING_MODE: BigNumber.ROUND_HALF_EVEN,
  ERRORS: false
});

$.xhrPool = [];
$.xhrPool.abortAll = function () {
  $(this).
    each((i, xhr) => {
      xhr.abort();
    });
  $.xhrPool.length = 0;
};

const ajaxOptions = function (options) {
  options || (options = {});
  return {
    beforeSend (xhr) {
      appContext.injectRequestHeaders(xhr, options);
      $.xhrPool.push(xhr);
    },
    complete (xhr) {
      const index = $.xhrPool.indexOf(xhr);
      if (index > -1) {
        $.xhrPool.splice(index, 1);
      }
    },
    cache: false
  };
};

const updateSync = function (oldSync, context) {
  return function (method, model, options) {
    options = _.extend(options, ajaxOptions(options));
    return context ? oldSync.call(this, method, model, options) : oldSync(method, model, options);
  };
};

// Update request handlers everywhere
$.ajaxSetup(ajaxOptions());
Backbone.sync = updateSync(Backbone.sync);


$(document).
  ajaxError((event, xhr) => {
    let errors;
    let message;

    if (xhr.status === 403) {
      errors = Errors.getErrors(xhr);
      Alert.clear().
        error({
          title: appContext.tr('Forbidden'),
          text: errors.message
        });
    } else if (xhr.status === 511) {
      const response_data = Errors.getErrors(xhr).data;
      const bindingUrl = appContext.url('connectionsList', {account_id: response_data.account_id});
      const text = translation.tr('Invalid credentials for <b>{0}</b> (account <b>{1}</b>).\nPlease,' +
        ' <a href="{2}">relink it</a>.').
        format(_.escape(response_data.descriptive_name),
          _.escape(response_data.account_name), bindingUrl);
      Alert.clear().
        error({
          title: translation.tr('Credentials expired'),
          text
        });
    } else if (xhr.status >= 500) {

      /*
       * TODO: There can be no status if request completely failed (proxy-server not responded for example.)
       * This behaviour should be handled.
       * But this situation can happen in case of xhr.abort(). See $.xhrPool.abortAll above.
       */
      message = Errors.getErrors(xhr).message;
      Alert.clear().
        error({
          title: translation.tr('Server Error'),
          text: message ? message : translation.tr('Server Error occurred ({0})').
            format(xhr.status)
        });
    }
  });

